// /checkout/success — fallback usado quando o submit do checkout não tem
// payment_url (caso de trial ou sem redirect explícito).
// Em prod o cliente quase nunca chega aqui — vai pro Asaas direto.
//
// VISUAL: kit do checkout público — mesmo creme/preto do CheckoutFlow.
// Antes usava os tokens escuros do painel admin (bg-page/bg-panel/text-ink).

import { CheckCircle2 } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';

import { CheckoutCenterCard, CheckoutShell } from '../../components/checkout-public/kit';

export function CheckoutSuccessPage(): JSX.Element {
  const [params] = useSearchParams();
  const isTrial = params.get('trial') === '1';

  return (
    <CheckoutShell title="TUDO CERTO">
      <CheckoutCenterCard>
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-teal-600">
          <CheckCircle2 size={28} strokeWidth={2} className="text-white" />
        </span>
        <h2 className="mt-4 text-[22px] font-black tracking-tight text-black">
          {isTrial ? 'Trial iniciado!' : 'Tudo certo!'}
        </h2>
        <p className="mt-2 text-[13px] leading-relaxed text-black/60">
          {isTrial
            ? 'Seu período grátis começou. Acesse o sistema com o e-mail que cadastrou.'
            : 'Em alguns segundos você recebe a confirmação por e-mail.'}
        </p>
      </CheckoutCenterCard>
    </CheckoutShell>
  );
}
